import { List, Text } from "@ucl/react-library";

interface SelectTileProps {
  title: string;
  description?: any[];
}

export const SelectTile = ({ title, description }: SelectTileProps) => {

  return (
    <div className="flex flex-col p-5 pb-0 gap-2">
      <Text renderAs="h3" styleType="h5" fontWeight="semi-bold">
        {title}
      </Text>
      {description?.map((desc) => (
        <div key={desc}>
          {Array.isArray(desc) ?
            <List type="bullet">
              {desc.map((item) => (
                <List.Item key={item} ><Text.P size="large">{item}</Text.P></List.Item>
              ))}
            </List> : <Text.P size="large">{desc}</Text.P>}
        </div>
      ))}
    </div>
  );
};